import { settingShare, saveRecentRole } from "@/api/api"
import bus from "@/lib/bus"
import wx from "weixin-js-sdk"

import {
  initUIComponents,
  updateConfig,
  getUserInfo,
} from "@qcplay/platform-ui"
import { platformStore } from "@/store/index"
import { useI18n } from "vue-i18n"
import QCJumpAuthPlugin from "@qcplay/jump-auth" //免密登录SDK

// 判断当前用户设备
export const getDeviceType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  // 判断是否为 Android 设备
  if (/android/i.test(userAgent)) {
    return "android"
  }

  // 判断是否为 iOS 设备 (iPhone, iPad, iPod)
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios"
  }

  // 其他设备
  return ""
}
// 配置多语言替换
export const i18nReplace = (e) => {
  const { t } = useI18n()
  // 检查是否为空或非字符串
  if (!e || typeof e !== "string") {
    return e
  }

  // 正则匹配所有 {xxx} 格式,使用 g 标志进行全局匹配
  const regex = /\{([^}]+)\}/g

  // 替换所有匹配的 {key} 为对应的翻译
  const result = e.replace(regex, (match, key) => {
    return t(key)
  })
  return result
}
// 配置多语言替换(用于setup内)
export const i18nReplaceSec = (e, t) => {
  // 检查是否为空或非字符串
  if (!e || typeof e !== "string") {
    return e
  }

  // 正则匹配所有 {xxx} 格式
  const regex = /\{([^}]+)\}/g

  // 替换所有匹配的 {key} 为对应的翻译
  const result = e.replace(regex, (match, key) => {
    return t(key)
  })

  return result
}
// 重构之后的多语言配置
export const getI18nLangConfigText = (item, type, i18nConfig = {}, needValue = false) => {
  // 如果没有 i18n 配置，直接返回原始字段
  let key = item[type]
  const t = (key) => window.$i18n?.t?.(key) ?? key
  const regex = /\{([^}]+)\}/g
  // 兼容老配置
  if (regex.test(key)) {
    key = key.replace(regex, (match, key) => {
      return t(key)
    })
  }
  if (!item.i18n && !i18nConfig) return key
  const store = platformStore()
  const lang = store.lang
  const globalLang = store.availableLanguages[0]?.lang_const
  const keysOwn = Object.keys(item.i18n || {})
  // 如果没有任何语言配置，返回原始字段
  if (keysOwn.length) {
    // 获取目标语言配置，如果不存在则使用第一个可用语言
    const targetLang = item.i18n[lang] ? lang : (globalLang || keysOwn[0])
    let result = item.i18n[targetLang]?.config[key]
    if (result) {
      // 兼容老配置
      if (regex.test(result)) {
        result = result.replace(regex, (match, key) => {
          return t(key)
        })
      }
      return result
    }
  }
  const keysTop = Object.keys(i18nConfig || {})
  if (keysTop.length) {
    // 获取目标语言配置，如果不存在则使用第一个可用语言（全局存的）
    const targetLang = i18nConfig[lang] ? lang : (globalLang || keysTop[0])
    let result = i18nConfig[targetLang]?.config[key]
    // 兼容老配置
    if (result && regex.test(result)) {
      result = result.replace(regex, (match, key) => {
        return t(key)
      })
    }
    return needValue ? (result || '') : result
  }
  return needValue ? (key || '') : key
}
// 微信网页分享配置
export const wechatShareAction = () => {
  const ua = navigator.userAgent.toLowerCase()
  if (!ua.includes("micromessenger")) return
  const shareData = {
    title: "青瓷游戏官方充值中心",
    desc: "青瓷游戏官方充值平台，福利活动多多，收藏不容错过！",
    imgUrl:
      "https://download4.qcplay.com/qcgame-api/UEmJqYdk2o4QGmIykwy1xPURevYHdh3a0sS7wuEw.png",
  }

  const wxReadyHandle = (url) => {
    const data = { ...shareData, link: url }
    wx.updateAppMessageShareData(data)
    wx.updateTimelineShareData(data)
  }
  // 微信分享配置
  const wechatShare = () => {
    const params = window.location.href
    settingShare({ uri: params }).then((json) => {
      wx.config(json.data)
      wx.ready(() => {
        wxReadyHandle(params)
      })
    })
  }
  return wechatShare()
}

// 每日PWA弹窗
export const storeParameterOncePerDay = (key) => {
  const setParameterOncePerDay = () => {
    const today = new Date().toDateString()
    const store = platformStore()
    const storedData = JSON.parse(localStorage.getItem(key))
    if (!storedData || storedData.date !== today) {
      const data = {
        date: today,
      }
      if (store.popupType == 1) {
        bus.$emit("deskTop", "showChecked")
      }
      localStorage.setItem(key, JSON.stringify(data))
    }
  }

  const getParameter = () => {
    const storedData = localStorage.getItem(key)
    if (!storedData) return null

    const parsedData = JSON.parse(storedData)
    const today = new Date().toDateString()

    if (parsedData.date !== today) {
      localStorage.removeItem(key)
      return null
    }

    return parsedData.date
  }

  setParameterOncePerDay()
  return getParameter()
}
// 登录初始化google id
/**
 * 根据当前域名和 gameId 获取对应的 Google OAuth Client ID
 * @returns {string} Google OAuth Client ID，未匹配时返回空字符串
 */
export function initGoogleId() {
  const { gameId } = platformStore()
  const href = window.location.href

  /**
   * 域名 -> Google Client ID 映射表
   * 支持按 gameId 区分的场景使用 { [gameId]: id, default: id } 格式
   * 不需要按 gameId 区分的场景直接使用字符串
   */
  const GOOGLE_ID_MAP = {
    "qcplay.co.jp": {
      78: "873001755659-gc8uidjs5dkvuraqjtkfgpeg1tav7mlo.apps.googleusercontent.com",
      default: "287713477898-oiqtjv6r5b0ve0hg9v61tb3v5o584oji.apps.googleusercontent.com",
    },
    "qcplay.com": "4750573344-r99j5sj2godq5ub9sd6pq9s7d3abuikb.apps.googleusercontent.com",
    "barleyplay.com": {
      115: "138072907702-lced8bhqbs821ft98vcnoeu7191fhmga.apps.googleusercontent.com",
      default: "294746021429-6kgp7df6rvt5an40nomc9d5q62mpm59u.apps.googleusercontent.com",
    },
    "snell.com.tw": {
      120: "981523495939-nb8j8v4qcice9hfmvnjcauaeb9drd0i2.apps.googleusercontent.com",
      38: "137757093762-0s7cdk8sgb9bmsrm5jsh0rapgu8i8e9q.apps.googleusercontent.com",
      default: "809371455711-ga0198gq9aefgmksjoim0ri5chgs2f72.apps.googleusercontent.com",
    },
    "supersnail.vn": "973818306462-rmh8o55u4mvv3ji5on4bshdq3mlt9hrg.apps.googleusercontent.com",
    "qcplay.co.kr": "303523189012-7ti8iahi1jv41upcf6pggj6oingqe807.apps.googleusercontent.com",
    "cardcaptor.vn": {
      121: "1035275619088-0ltslgkn4fup10glel67o76v4q32cauk.apps.googleusercontent.com",
      default: "973818306462-rmh8o55u4mvv3ji5on4bshdq3mlt9hrg.apps.googleusercontent.com",
    },
    "karaqgames.com": "181311055899-nptj4c3h0gcpk2aumtc7et1if7bf1t57.apps.googleusercontent.com",
  }

  const matchedDomain = Object.keys(GOOGLE_ID_MAP).find(domain => href.includes(domain))
  if (!matchedDomain) return ""

  const config = GOOGLE_ID_MAP[matchedDomain]
  // 直接字符串：无需按 gameId 区分
  if (typeof config === "string") return config
  // 对象：优先匹配 gameId，否则使用 default
  return config[gameId] || config.default || ""
}
/**
 * 根据当前域名和 gameId 获取对应的 Apple Sign-In Service ID
 * @returns {string} Apple Service ID，未匹配时返回空字符串
 */
export function initAppleId() {
  const { gameId } = platformStore()
  const href = window.location.href

  /** 域名 -> Apple Service ID 映射表 */
  const APPLE_ID_MAP = {
    "qcplay.co.jp": {
      78: "fejsf.sign.in.with",
      default: "com.qcplay.snail.ios.jp.sign-in-with-apple",
    },
    "qcplay.com": "com.qcplay.snail.ios.na.sign-in-with-apple",
    "barleyplay.com": {
      115: "com.qcplay.xjqxz.ios.sea.sign-in-with-apple",
      default: "com.qcplay.snail.ios.sea2.sign-in-with-apple",
    },
    "snell.com.tw": {
      120: "com.ltgames.ios.snail.sign-in-with-apple",
      38: "com.qcplay.timetravel.tw.sign-in-with-apple",
      default: "com.snell.sakura.aps.tw.sign-in-with-apple",
    },
    "supersnail.vn": "com.qcplay.snail.ios.sea.sign-in-with-apple",
    "qcplay.co.kr": "com.qcplay.snail.ios.kr.sign-in-with-apple",
    "cardcaptor.vn": {
      121: "com.qcplay.sakura.ios.vn.sign-in-with-apple",
      default: "com.qcplay.snail.ios.sea.sign-in-with-apple",
    },
    "karaqgames.com": "com.karaq.sakura.jp.sign-in-with-apple",
  }

  const matchedDomain = Object.keys(APPLE_ID_MAP).find(domain => href.includes(domain))
  if (!matchedDomain) return ""

  const config = APPLE_ID_MAP[matchedDomain]
  if (typeof config === "string") return config
  return config[gameId] || config.default || ""
}

/**
 * 根据当前域名和 gameId 获取对应的 Facebook App ID
 * @returns {string} Facebook App ID，未匹配时返回空字符串
 */
export function initFacebookId() {
  const { gameId } = platformStore()
  const href = window.location.href

  /** 域名 -> Facebook App ID 映射表 */
  const FACEBOOK_ID_MAP = {
    "qcplay.co.jp": {
      78: "3657920144452495",
      default: "951101598953228",
    },
    "qcplay.com": "467595308549623",
    "barleyplay.com": "",
    "snell.com.tw": {
      120: "747996759031598",
      38: "",
      default: "836248714445831",
    },
    "supersnail.vn": "",
    "qcplay.co.kr": "",
    "cardcaptor.vn": "1758721508100865",
    "karaqgames.com": "",
  }

  const matchedDomain = Object.keys(FACEBOOK_ID_MAP).find(domain => href.includes(domain))
  if (!matchedDomain) return ""

  const config = FACEBOOK_ID_MAP[matchedDomain]
  if (typeof config === "string") return config
  return config[gameId] || config.default || ""
}

/**
 * 根据当前域名和 gameId 获取对应的 BundleId
 * @returns {string} BundleId，未匹配时返回 "com.qcplay.h5"
 */
export function initBundleId() {
  const { gameId } = platformStore()
  const href = window.location.href

  const DEFAULT_BUNDLE_ID = "com.qcplay.h5"
  const NW_CONVERT_BUNDLE_ID = "com.qcplay.nwh5"

  const isNwConvertRoute =
    /^\/nwconvert(?:\/|$)/.test(window.location.pathname) ||
    /^#?\/nwconvert(?:\/|$)/.test(window.location.hash)

  if (isNwConvertRoute) return NW_CONVERT_BUNDLE_ID

  /** 域名 -> BundleId 映射表 */
  const BUNDLE_ID_MAP = {
    "qcplay.co.jp": {
      78: "com.qcplay.web.h5",
      default: DEFAULT_BUNDLE_ID,
    },
    "qcplay.com": DEFAULT_BUNDLE_ID,
    "barleyplay.com": {
      115: DEFAULT_BUNDLE_ID,
      default: "com.qcplay.sea2.h5",
    },
    "snell.com.tw": DEFAULT_BUNDLE_ID,
    "supersnail.vn": "com.qcplay.sea.h5",
    "qcplay.co.kr": DEFAULT_BUNDLE_ID,
    "cardcaptor.vn": {
      121: DEFAULT_BUNDLE_ID,
      default: "com.qcplay.sea.h5",
    },
    "karaqgames.com": DEFAULT_BUNDLE_ID,
    "qingcigame.com": DEFAULT_BUNDLE_ID,
  }

  const matchedDomain = Object.keys(BUNDLE_ID_MAP).find(domain => href.includes(domain))
  if (!matchedDomain) return DEFAULT_BUNDLE_ID

  const config = BUNDLE_ID_MAP[matchedDomain]
  if (typeof config === "string") return config
  return config[gameId] || config.default || DEFAULT_BUNDLE_ID
}
/**
 * 初始化SDK模块
 * @returns {Promise} 返回Promise对象，支持.then()调用
 */
export const initSDK = () => {
  const store = platformStore()
  const packageName = initBundleId()
  console.log("请求参数:", initBundleId())
  let region = store.nowType == "zhcn" ? "domestic" : "overseas" //overseas海外，domestic国内
  // if (process.env.NODE_ENV != "production") {
  //   //开发环境用
  //   region = "domestic"
  // }
  /**
   * 根据 Git 分支判断环境
   * test 分支 -> development (测试环境)
   * master 分支 -> production (生产环境)
   */
  const buildEnvironment = process.env.BUILD_ENVIRONMENT || "production" // 构建时注入的环境变量
  let sdkEnvironment =
    buildEnvironment === "development" ? "development" : "production"
  if (process.env.NODE_ENV != "production") {
    //开发环境用
    sdkEnvironment = "development"
  }
  return initUIComponents({
    gameId: store.gameId,
    region: region,
    packageName: packageName,
    language: store.lang || "zh-cn",
    isNeedWechatPay: true, //是否为微信支付
    environment: sdkEnvironment, // 根据 Git 分支自动判断：test分支为development，master分支为production
  })
    .then(() => {
      return Promise.resolve() // 确保返回成功的Promise
    })
    .catch((err) => {
      console.log("initUIComponents error", err)
      return Promise.reject(err) // 确保返回失败的Promise
    })
}
// 切换游戏区服或者切换语言信息重新加载SDK
export const reloadSDK = () => {
  const store = platformStore()
  const packageName = initBundleId()
  let region = store.nowType == "zhcn" ? "domestic" : "overseas" //overseas海外，domestic国内
  // if (process.env.NODE_ENV != "production") {
  //   //开发环境用
  //   region = "domestic"
  // }
  return updateConfig({
    gameId: store.gameId,
    region: region,
    packageName: packageName,
    language: store.lang || "zh-cn",
  })
    .then(() => {
      console.log("updateConfig ok")
      return Promise.resolve() // 确保返回成功的Promise
    })
    .catch((err) => {
      console.log("updateConfig error", err)
      return Promise.reject(err) // 确保返回失败的Promise
    })
}
// 字体大小判断
export function getBaseFontSize() {
  const langMap = {
    "qcplay.co.jp": 1,
    "qcplay.com": 1,
    "barleyplay.com": 1,
    "snell.com.tw": 1,
    "supersnail.vn": 1,
    "qcplay.co.kr": 1,
    "cardcaptor.vn": 1,
    "qingcigame.com": 1,
    "karaqgames.com": 1,
  }
  let fontSizeNum = ""
  for (let i in langMap) {
    if (window.location.href.includes(i)) {
      fontSizeNum = langMap[i]
    }
  }
  return fontSizeNum
}

/**
 * 根据当前访问域名动态获取应用名称（运行时）
 * @returns {string} 应用名称
 */
export function getAppNameByDomain() {
  const href = window.location.href

  // 域名与应用名称的映射关系
  const domainNameMap = {
    "qcplay.co.jp": "QCPlayトークンストア",
    "qcplay.com": "QCPLAY PAYMENT CENTER",
    "barleyplay.com": "QCPLAY PAYMENT CENTER",
    "snell.com.tw": "Snell Game遊戲官方儲值中心",
    "supersnail.vn": "Web Nạp Chính Thức VISION NETWORK",
    "cardcaptor.vn": "Web Nạp Chính Thức VISION NETWORK",
    "qingcigame.com": "青瓷游戏官方充值中心",
    "karaqgames.com": "KaraQ公式ストア",
  }

  // 遍历映射表,查找匹配的域名
  for (let key in domainNameMap) {
    if (href.includes(key)) {
      return domainNameMap[key]
    }
  }

  // 默认返回中文名称
  return "青瓷游戏官方充值中心"
}
/**
 * 数字千分位转换
 */
export function formatNumber(num) {
  const store = platformStore()
  // 处理 null、undefined 和非数字值
  if (num == null || num === "") {
    return "0"
  }

  // 转换为数字
  const number = Number(num)

  // 如果不是有效数字，返回原值或0
  if (isNaN(number)) {
    return String(num)
  }

  // 将数字转换为字符串，处理小数
  const parts = number.toString().split(".")

  // 对整数部分添加千分位
  if (store.lang == "vi-vn") {
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  } else parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")

  // 如果有小数部分，拼接回去
  return parts.length > 1 ? parts.join(".") : parts[0]
}
/**
 * 免密登录模块
 * @param {Object} router - Vue Router 实例(用于导航)
 * @param {Object} route - 当前路由对象(包含路由信息)
 */
export async function processPayment(router, route) {
  let qcJumpAuth = {}
  const store = platformStore()
  const buildEnvironment = process.env.BUILD_ENVIRONMENT || "production" // 构建时注入的环境变量
  let sdkEnvironment =
    buildEnvironment === "development" ? "development" : "production"
  if (process.env.NODE_ENV != "production") {
    //开发环境用
    sdkEnvironment = "development"
  }

  qcJumpAuth = new QCJumpAuthPlugin({
    gameId: route.query.gameId,
    language: store.lang,
    useV5: true,
    environment: sdkEnvironment, // 测试环境development，生产环境production
  })
  const newQuery = { ...route.query }
  delete newQuery.token
  delete newQuery.auth_code
  const info = await qcJumpAuth
    .processAuthCode()
    .then((res) => {
      console.log("res", res)
      return res // 必须返回结果
    })
    .catch((err) => {
      console.error("processAuthCode 调用失败:", err)
      router.replace({ query: newQuery })
      return { _error: true } // 返回错误标记
    })

  // 检查是否发生错误，如果是则直接返回，不继续执行
  if (info._error) {
    console.log("发生错误，已跳转，停止后续执行")
    return
  }

  if (info.access_token) {
    store.setAccessToken(info.access_token)
    if (store.nowType == "zhcn") {
      // 国内地区需要手动去获取手机号
      await getUserInfo(info.access_token).then((res) => {
        if (res.metadata.account_info && res.metadata.account_info.length > 0) {
          store.setMobile(res.metadata.account_info[0].name)
        } else {
          store.setMobile(info.email || info.user_id)
        }
      })
    } else {
      store.setMobile(info.email || info.user_id)

    }
    store.setUserId(info.user_id)
    store.setLoginWay('qcplay')
    store.setGameId(info.game_id)
    store.setPasswordLoginList(info)
    bus.$emit("sendToken", info.access_token)
    // 保存免密登录的角色为最近使用角色
    await saveRecentRole({
      game_id: info.game_id,
      role_id: info.role_id,
      parent_game_id: 0,
    })
    store.setBackGameUrl(info.return_url || "")
    store.setFromGameSkuId(info.product_id || "")
    router.replace({ query: newQuery })
  } else {
    router.replace({ query: newQuery })
  }
}
// 导出模块
export default {
  getDeviceType,
  i18nReplaceSec,
  i18nReplace,
  reloadSDK,
  initSDK,
  getI18nLangConfigText,
}
